export enum RolesEnum  {

    SALES = 'sales',
    ORDER_WRITE = 'order_write',

    // Commerce
    CUSTOMER_WRITE = 'customer_write', // Multipress only
    COMMERCE_WRITE = 'commerce_write', // Edit Web shops
    PRODUCT_WRITE = 'product_write', // Edit products catalog

    // Pre-press
    SCRIPT_WRITE = 'script_write',
    PREPRESS_WRITE = 'prepress_write',
    ADVANCED = 'advanced',

    // Production
    PRODUCTION_WRITE = 'production_write',
    PLANNING_WRITE = 'planning_write',

    // Installation (pose)
    INSTALLATION_ADMIN = 'installation_admin',
    INSTALLER = 'installer',

    // Subcontracting
    EXTERNAL_PRODUCTION_WRITE = 'external_production_write', // Subcontracting notifications and acceptation

    // Transport
    SHIPMENT_READ = 'shipment_read',
    SHIPMENT_WRITE = 'shipment_write',
    WORKSHOP_WRITE = 'workshop_write',

    // Administration
    USER_WRITE = 'user_write',
    SETTING_WRITE = 'setting_write',

    // Stocks
    STOCK_WRITE = 'stock_write',

    // Plugins
    IMPORT_WRITE = 'import_write',
    MULTIPRESS_WRITE = 'multipress_write',
}

